<template>
  <div>
    <div class="bg">

      <Nav :title="title" @getTime="getTime" @address="address"/>
      <div class="grid-pro">

        <div class="grid-pro-three">
          <div style="width: 100%; height: 740px;">
            <div style="padding: 10px;height: 100%;">
              <div
                  style="text-align: left;padding: 5px;display: flex;justify-content: space-between;align-items: center;">
                <div style="font-size: 16px;font-family: Arial;width: 30%">传播排行榜</div>
                <el-button style="background-color: transparent;color: #409EFF;padding: 7px 9px" size="small" @click="futureWeek" type="primary">过去一周</el-button>
                <el-button style="background-color: transparent;color: #409EFF;padding: 7px 9px" size="small" @click="futureHelfYear" type="primary">过去半年</el-button>
                <el-button style="background-color: transparent;color: #409EFF;padding: 7px 9px" size="small" @click="futureYear" type="primary">过去一年</el-button>
                <inputSearch v-model="inputValue" @focus="focus" @blur="blur" @search="handEnter"/>
              </div>
              <!--一个盒子-->
              <div class="overflow-box">
                <div v-for="(i, index) in getSpread" :key="index" style="height: 65px;"
                     :class="[index % 2 != 0 ? 'bgColor' : '']">
                  <div style="display: flex;justify-content: space-between;align-items: center;padding: 5px;">
                    <div style="display: flex;justify-content: left;align-items: center;width: 85%;">
                      <div style="text-align: left">{{ index + 1 }}</div>
                      <div class="text-multi-line-ellipsis">{{ i.content }}</div>
                    </div>
                    <div>
                      <el-button style="background-color: transparent;" size="mini" @click="indexDetail(i.id)">详情
                      </el-button>
                    </div>
                  </div>
                  <div style="padding: 5px;display: flex;justify-content: space-between;align-items: center;">
                    <div>传播力:{{ i.reposts_count }}</div>
                    <div style="display: flex;justify-content: left;align-items: center;">
                      <i class="el-icon-picture-outline-round"></i>
                      <div>作者:{{ i.user_name }}</div>
                    </div>
                    <div>
                      <i class="el-icon-time"></i>
                      {{ i.publish_time }}
                    </div>
                  </div>
                </div>
              </div>
              <!--一个盒子-->
            </div>
          </div>
        </div>
        <div class="grid-pro-five">
          <div style="width: 100%; height: 100%;">
            <div style="padding: 10px;text-align: center;height: 100%;background-color:transparent;">
              <div style="display: flex;justify-content: space-between;align-items: center;height: 100%">
                <div
                    style="width: 100%;height: 100%;display: flex;flex-direction: column;justify-content: space-between">
                  <div style="display: flex;justify-content: center;margin: 0 auto">
                    <div class="backGround-line">传播趋势</div>
                  </div>
                  <div id="spreadTrendsChart" style="width: 100%;height: 90%;"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isMaskVisible" class="mask">
      <div class="mask-content">
        <div style="display: flex;justify-content: right;align-items: center;height: 100%">
          <div style="width:80%;height: 100%;margin:  0 auto">
            <div v-if="listDetailIndex !=0" class="overflow-box-1">
              <div v-for="(i, index) in listDetailIndex" :key="index" style="height: 65px;"
                   :class="[index % 2 != 0 ? 'bgColor' : '']">
                <div style="display: flex;justify-content: space-between;align-items: center;padding: 5px;">
                  <div style="display: flex;justify-content: left;align-items: center;width: 85%;">
                    <div style="text-align: left">{{ index + 1 }}</div>
                    <div class="text-multi-line-ellipsis">{{ i.content }}</div>
                  </div>
                  <div>
                    <el-button @click="indexDetail(i.id)" style="background-color: transparent;" size="mini">详情
                    </el-button>
                  </div>
                </div>
                <div style="padding: 5px;display: flex;justify-content: space-between;align-items: center;">
                  <div>传播力:{{ i.reposts_count }}</div>
                  <div style="display: flex;justify-content: left;align-items: center;">
                    <i class="el-icon-picture-outline-round"></i>
                    <div>作者{{ i.user_name }}</div>
                  </div>
                  <div>
                    <i class="el-icon-time"></i>
                    {{ i.publish_time }}
                  </div>
                </div>
              </div>
            </div>
            <div v-if="listDetailIndex.length == 0">
              <el-empty description="暂无内容"></el-empty>
            </div>
          </div>

        </div>
        <el-button @click="isMaskVisible=false" size="small" style="background-color: transparent">关闭</el-button>
      </div>
    </div>

    <div v-if="isMaskVisible1" class="mask">
      <div class="mask-content">
        <div style="display: flex;justify-content: right;align-items: center;height: 100%">
          <div style="width:100%;height: 100%;display: flex;flex-direction: column;justify-content: space-between">
            <div style="height: 54%;width: 100%;display: flex;justify-content: space-between">
              <div  style="background-color:rgb(255,255,255,0.1);width: 29%;border-radius: 12px;">
                <div class="backGround-line">传播路径</div>
                     <div class="wrap-pne">
                       <div>
                         此信息由
                         <span style="color: red">{{SpreadAnalysisDetail.user_name}}</span>
                         首发,戒指最后一条相关数据，传播时长共计
                         <span style="color: red">{{SpreadAnalysisDetail.duration_time}}</span>
                         ， 传播量为
                         <span style="color: red">{{SpreadAnalysisDetail.reposts_count}}</span>
                         ，评论数量为
                         <span style="color: red">{{SpreadAnalysisDetail.comments_count}}</span>
                       </div>
                     </div>
              </div>
              <div style="background-color:rgb(255,255,255,0.1);width: 69%;border-radius: 12px">
                <div class="backGround-line">传播趋势</div>
                <div id="trend" style="width: 100%;height: 100%"></div>
              </div>
            </div>
            <div style="height: 43%;background-color: rgb(255,255,255,0.1);border-radius: 12px">
              <div class="backGround-line">传播事件</div>
                 <div id="path" style="width: 100%;height: 90%;"></div>
            </div>
          </div>

        </div>
        <el-button @click="isMaskVisible1=false" size="small" style="background-color: transparent">关闭</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "_c/Nav/Nav.vue";
import * as echarts from 'echarts';
import inputSearch from "@/components/inputSearch/inputSearch.vue";
import {
  spreadAnalysisGetSpreadTop10,
  spreadAnalysisGetSpreadTrend,
  spreadAnalysisGetSpreadSearch,
  spreadAnalysisGetSpreadAnalysisDetail
} from '@/request/propagation/propagation'

export default {
  components: {
    Nav, inputSearch
  },
  data() {
    return {
      isMaskVisible: false, // 搜索的遮罩
      isMaskVisible1: false, // 详情的遮罩
      form: {},      // 时间参数
      loading: true,
      title: "传播分析",
      listDetailIndex: [], // 存储搜索出来的数据
      SpreadAnalysisDetail: [],// 数据的详情
      inputValue: '',   // 输入框里面的
      chart_2: null, // 传播趋势图
      chart_3: null, // 详情里面的河流图
      chart_4: null, // 详情里面的旭日图
      getSpread: [],// 七天传播排行榜
    }
  },
  mounted() {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    this.getSpreadTop()
    this.$nextTick(() => {
      this.myChartSpreadTrends()
    })
    loading.close();
  },
  methods: {
    // 传播排行邦
    getSpreadTop() {
      spreadAnalysisGetSpreadTop10().then(res => {
        this.getSpread = res.data.data
      })
    },
    // 传播趋势图
    myChartSpreadTrends() {
      this.chart_2 = echarts.init(document.getElementById('spreadTrendsChart'))
      spreadAnalysisGetSpreadTrend().then(res => {
        const seriesData = res.data.data.map(item => item.count)
        const xAxisList = res.data.data.map(item => item.date)
        const textColor = '#fff'
        this.chart_2.setOption({
          tooltip: {
            trigger: 'axis'
          },
          legend:{
            textStyle: {  // 控制图例文字样式
              color: '#353bbc', // 修改为白色
              fontSize: 12,
              fontWeight: 'bold'
            }
          },
          grid: {
            top: '15%',
            left: '15%',
            right: '15%',
            bottom: '15%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: xAxisList,
            axisLabel: {
              // 坐标轴字体颜色
              color: textColor,
              fontSize: 18
            },
            axisLine: {
              lineStyle: {
                color: textColor
              }
            },
            axisTick: {
              // y轴刻度线
              show: true
            },
            splitLine: {
              // 网格
              show: false
            },
            boundaryGap: false
          },
          yAxis: {
            type: 'value',
            min: 0,
            name: '发布量',
            nameTextStyle: {
              color: '#333',
              fontSize: 18,
              padding: [0, 0, 0, 80]
            },
            axisLabel: {
              // 坐标轴字体颜色
              color: textColor,
              fontSize: 18
            },
            axisLine: {
              show: true
            },
            axisTick: {
              // y轴刻度线
              show: false
            },
            splitLine: {
              // 网格
              show: true,
              lineStyle: {
                color: '#CCCCCC',
                type: 'dashed'
              }
            }
          },

          series: [
            {
              name: '发布量',
              type: 'line',
              symbol: 'circle',
              symbolSize: 10,
              z: 1,
              itemStyle: {
                color: '#5487FF'
              },
              lineStyle: {
                color: '#5487FF'
              },
              data: seriesData
            }
          ]
        })
      })
    },
    // 数据的详情
    indexDetail(value) {
      this.isMaskVisible1 = true
      spreadAnalysisGetSpreadAnalysisDetail({id: value}).then(res => {
        this.SpreadAnalysisDetail = res.data.data.detail
        const data = res.data.data.trend.seriesData
        const legendData = res.data.data.trend.legendData

        this.chart_3 = echarts.init(document.getElementById('trend'))
        this.chart_3.setOption({
          backgroundColor: "transparent",
          color: ["#C58080", "#E1A4C4", "#C03C71", "#8C2487",  ],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'line',
              lineStyle: {
                color: 'rgba(255,255,0,0.8)',
                width: 1,
                type: 'solid'
              }
            }
          },

          legend: {
            top: '4%',
            textStyle: {
              color: '#FE80C8',
            },
            data: legendData
          },

          singleAxis: {
            top: 90,
            bottom: 90,
            left: 100,
            right: 100,
            axisLine: {
              lineStyle: {
                color: '#5F4051'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#5F4051',
              }
            },
            type: 'time',
            axisPointer: {
              animation: true,
              label: {
                show: true
              }
            },
          },

          series: [{
            type: 'themeRiver',
            label: {
              normal: {
                show: false,
                position: 'left'
              }
            },
            itemStyle: {
              emphasis: {
                shadowBlur: 20,
                shadowColor: 'rgba(0, 0, 0, 0.6)'
              }
            },
            data: data
          }]})

        this.chart_4 = echarts.init(document.getElementById('path'))
        function init(data) {
          let category;
          //初始角度从最上方顺时针开始
          //右边数字放在label后面 左边数字放再label前面
          //蓝光圈半径
          const blueAngle = 25;
          const color = ['#0a324d', '#2b1f46', '#061d53'];
          const dotColor = ['#2cd28c', '#ec5c5f', '#216de6'];
          const dotColorList = initDotColor(data);
          function initDotColor(data) {
            let res = [];
            let length = 0;
            data.forEach((item, index) => {
              const preLength = length;
              length += item.children.length * 2;
              res = res.concat(new Array(length - preLength).fill(dotColor[index]));
            });
            return res;
          }
          initData();
          function initData() {
            data.forEach((item) => {
              item.children.forEach((item1) => {
                item1.value = [1, item1.value || ''];
              });
            });
          }
          const length =
              data.reduce((sum, item) => {
                return sum + item.children.length;
              }, 0) * 2;
          category = Array.from({ length }, (v, k) => k);
          //奇数
          var customData = category.filter(item => item % 2).map(item => [40, item]);
          //label点击
          //   myChart.on('click', function (params) {
          //     console.log(params);
          //   });
          return {
            backgroundColor: 'transparent',
            polar: {},
            grid: {
              top: 0,
              left: 0,
            },
            angleAxis: {
              type: 'category',
              data: category,
              boundaryGap: false,
              splitLine: {
                show: false,
              },
              axiosTick: { show: false },
              axisLabel: { show: false },
              axisLine: {
                show: false,
              },
            },
            radiusAxis: {
              type: 'value',
              axisLine: {
                show: false,
              },
              splitLine: {
                show: false,
              },
              splitNumber: 1,
              axisLabel: {
                show: false,
              },
            },
            color,
            series: [
              {
                type: 'custom',
                coordinateSystem: 'polar',
                renderItem: function(params, api) {
                  const [r3, ] = api.coord([26, 0]);
                  return {
                    type: 'circle',
                    shape: {
                      cx: params.coordSys.cx,
                      cy: params.coordSys.cy,
                      r: r3,
                    },
                    style: {
                      fill: 'transparent',
                      lineWidth: blueAngle,
                      stroke: 'transparent',
                    },
                    silent: true,
                    styleEmphasis: {
                      shadowColor: '#2bce89',
                      shadowBlur: 20,
                      fill: '#2bce89',
                      lineWidth: 4,
                      stroke: '#2bce89',
                    },
                  };
                },
                data: [0],
              },
              {
                type: 'custom',
                coordinateSystem: 'polar',
                zlevel: -1,
                renderItem: function(params, api) {
                  const index = api.value(1);
                  const [x, y] = api.coord([31, index]);
                  const color = dotColorList[index];
                  return {
                    type: 'circle',
                    shape: {
                      cx: x,
                      cy: y,
                      r: 3,
                    },
                    style: {
                      fill: color,
                      align: 'center',
                      verticalAlign: 'middle',
                    },
                    styleEmphasis: {
                      shadowColor: color,
                      shadowBlur: 20,
                      fill: color,
                      lineWidth: 4,
                      stroke: color,
                    },
                  };
                },
                data: customData,
              },
              {
                type: 'sunburst',
                // startAngle: 0,
                data,
                radius: [0, '95%'],
                sort: undefined,
                highlightPolicy: 'ancestor',
                label: {
                  color: '#9b9fb0',
                  position: 'inside',
                  textBorderWidth: 0,
                  silent: false,
                  formatter: params => {
                    return `${params.name}  ${params.value[1] || ''}`;
                  },
                },
                downplay: {
                  label: {
                    formatter: params => {
                      return `${params.name}  ${params.value[1] || ''}`;
                    },
                  },
                },
                emphasis: {
                  label: {
                    formatter: params => {
                      return `${params.name}  ${params.value[1] || ''}`;
                    },
                  },
                },
                levels: [
                  {},
                  {
                    r0: '0%',
                    // r0: '10%',
                    r: '35%',
                    itemStyle: {
                      borderWidth: 0,
                      // color: 'transparent'
                    },
                  },
                  {
                    r0: '49%',
                    r: '50%',
                    label: {
                      silent: false,
                      textBorderWidth: 0,
                      fontSize: 8,
                      position: 'outside',
                      distance: 10,
                      color: '#9b9fb0',
                    },
                    itemStyle: {
                      silent: true,
                      color: 'transparent',
                      textBorderWidth: 0,
                      borderWidth: 6,
                      borderColor: 'transparent',
                      borderCap: 'round',
                      shadowBlur: 0,
                    },
                  },
                ],
              },
              {
                type: 'custom',
                coordinateSystem: 'polar',
                renderItem: function(params, api) {
                  //线 点中心
                  const index = api.value(1);
                  const [x1, y1] = api.coord([25.5, index]);
                  const [x2, y2] = api.coord([27, index]);

                  //圆弧开始结束
                  const start = index - 1;
                  const end = index + 1;
                  const [ r3, a3] = api.coord([24, start]);
                  const [ a4] = api.coord([24, end]);
                  return {
                    type: 'group',
                    children: [
                      {
                        type: 'arc',
                        shape: {
                          cx: params.coordSys.cx,
                          cy: params.coordSys.cy,
                          r0: 0,
                          r: r3,
                          startAngle: a4 + 0.05,
                          endAngle: a3 - 0.05,
                        },
                        style: {
                          stroke: 'rgba(102, 111, 139,.5)',
                          fill: 'transparent',
                          lineWidth: 1.5,
                        },
                      },
                      {
                        type: 'line',
                        shape: {
                          x1,
                          y1,
                          x2,
                          y2,
                        },
                        style: {
                          stroke: 'rgba(102, 111, 139,.5)',
                          lineWidth: 1.5,
                        },
                      },
                    ],
                  };
                },
                data: customData,
              },
            ],
          };
        }
        const  list = res.data.data.path.map(item => ({
          name:item.user_name,
          value:item.id
        }))
        let data1 = [{
            children: list
          }]
        const response = init(data1)
        this.chart_4.setOption(response)

      })
    },
    focus() {
      // console.log('获得焦点')
    },
    blur() {
      // console.log('失去焦点')
    },
    // 搜索后弹框出来
    handEnter() {
      this.isMaskVisible = true
      spreadAnalysisGetSpreadSearch({keyword: this.inputValue}).then(res => {
        this.listDetailIndex = res.data.data
      })
    },
    // 过去一周
    futureWeek(){
      const today = new Date();
      const firstDay = new Date(today);
      firstDay.setDate(today.getDate() - 6); // 6天前
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
      this.form = {
        startTime: formatDate(firstDay),
        endTime: formatDate(today),
      }
      spreadAnalysisGetSpreadTop10(this.form).then(res => {
        this.getSpread = res.data.data
      })
    },
    // 过去半年
    futureHelfYear(){
      function getHalfYearAgo(format = 'yyyy-mm-dd') {
        const date = new Date();
        date.setMonth(date.getMonth() - 6);
        // 处理跨年情况
        if (date.getMonth() > new Date().getMonth()) {
          date.setFullYear(date.getFullYear() - 1);
        }
        // 格式化函数
        const pad = num => String(num).padStart(2, '0');
        switch(format) {
          case 'yyyy-mm-dd':
            return `${date.getFullYear()}-${pad(date.getMonth()+1)}-${pad(date.getDate())}`;
          case 'dd/mm/yyyy':
            return `${pad(date.getDate())}/${pad(date.getMonth()+1)}/${date.getFullYear()}`;
          case 'timestamp':
            return date.getTime();
          default:
            return date;
        }
      }
      const time = getHalfYearAgo()
      const today = new Date();
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
      this.form = {
        startTime: time,
        endTime: formatDate(today),
      }
      spreadAnalysisGetSpreadTop10(this.form).then(res => {
        this.getSpread = res.data.data
      })
    },
    // 过去一年
    futureYear(){
      function getLastYearRange() {
        const today = new Date();
        const lastYearSameDay = new Date(today);
        lastYearSameDay.setFullYear(today.getFullYear() - 1);
        // 格式化为 yyyy-mm-dd
        function formatDate(date) {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        }

        return {
          start: formatDate(lastYearSameDay),
          end: formatDate(today)
        };
      }
      const lastYearRange = getLastYearRange();
      this.form = {
        startTime: lastYearRange.start,
        endTime: lastYearRange.end,
      }
      spreadAnalysisGetSpreadTop10(this.form).then(res => {
        this.getSpread = res.data.data
      })
    },
    getTime(value) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.form.startTime = value[0]
      this.form.endTime = value[1]
      spreadAnalysisGetSpreadTrend(this.form).then(res => {
        const seriesData = res.data.data.map(item => item.count)
        const xAxisList = res.data.data.map(item => item.date)
        const textColor = '#fff'
        this.chart_2.setOption({
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            top: '15%',
            left: '15%',
            right: '15%',
            bottom: '15%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: xAxisList,
            axisLabel: {
              // 坐标轴字体颜色
              color: textColor,
              fontSize: 18
            },
            axisLine: {
              lineStyle: {
                color: textColor
              }
            },
            axisTick: {
              // y轴刻度线
              show: true
            },
            splitLine: {
              // 网格
              show: false
            },
            boundaryGap: false
          },
          yAxis: {
            type: 'value',
            min: 0,
            name: '发布量',
            nameTextStyle: {
              color: '#333',
              fontSize: 18,
              padding: [0, 0, 0, 80]
            },
            axisLabel: {
              // 坐标轴字体颜色
              color: textColor,
              fontSize: 18
            },
            axisLine: {
              show: true
            },
            axisTick: {
              // y轴刻度线
              show: false
            },
            splitLine: {
              // 网格
              show: true,
              lineStyle: {
                color: '#CCCCCC',
                type: 'dashed'
              }
            }
          },

          series: [
            {
              name: '发布量',
              type: 'line',
              symbol: 'circle',
              symbolSize: 10,
              z: 1,
              itemStyle: {
                color: '#5487FF'
              },
              lineStyle: {
                color: '#5487FF'
              },
              data: seriesData
            }
          ]
        })
      })
      loading.close();
    },
    address() {

    }
  },
  computed: {}
}
</script>


<style scoped lang="css">
* {
  font-size: 14px;
  color: white;
}

.bg {
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  padding: 16px 16px 0 16px;
  background-image: url("../../assets/pageBg.png");
  background-size: cover;
  background-position: center center;
}

.pro-middle {
  background-color: #13192f99;
  height: 100%;
  padding: 10px;
  text-align: center;
  font-weight: inherit;
  font-family: Arial, Helvetica, sans-serif;
}

.grid-pro {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin: 20px auto 0 auto;
  height: 80%;
  gap: 10px;
}


.grid-pro-five {
  width: 60%;
  background-color: rgb(17, 27, 39);
}

.grid-pro-three {
  width: 40%;
  background-color: rgb(17, 27, 39);
}

.bgColor {
  background-color: rgb(255, 255, 255, 0.1);
}

.text-multi-line-ellipsis {
  display: -webkit-box;
  /* 老式弹性盒子模型 */
  -webkit-box-orient: vertical;
  /* 内容垂直排列 */
  -webkit-line-clamp: 1;
  /* 最多显示几行 */
  overflow: hidden;
  /* 隐藏多余内容 */
  text-overflow: ellipsis;
  /* 溢出部分显示省略号 */
  margin-left: 5px;
}

.overflow-box {
  height: 90%;
  /* 假设每条高 60px，最多显示 10 条 */
  overflow-y: auto;
  /* 可选：加个边框好看点 */
  padding: 5px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.overflow-box-1 {
  height: 100%;
  overflow-y: auto;
  /* 可选：加个边框好看点 */
  padding: 5px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.mask {
  position: fixed;
  //text-shadow: 0 0 5px white; /* 这会导致白光圈 */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明黑 */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 111;
}

/* 内容区域 */
.mask-content {
  width: 90%;
  background-color: rgba(15, 19, 37, 1);
  padding: 30px;
  height: 90%;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  text-align: center;
  color: #fff;
  min-width: 300px;
  position: relative;
}
.wrap-pne{
  flex-wrap: wrap;
  width: 100%;
  height: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
